import { Button, Table } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  cargosTable: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    '& th,td': {
      border: '1px solid black',
    },
  },
});
const AspiranteCargos = ({ cargos, onPostular = null }) => {
  const handleBases = () => {};
  const handlePostular = (cargo) => {
    onPostular?.(cargo);
  };
  return (
    <Table striped bordered>
      <thead>
        <tr>
          <th>Denominación del cargo</th>
          <th>Nivel</th>
          <th>Función específica</th>
          <th>Terciaria</th>
          <th className="text-center" title="Cargo con reserva">
            <i className="fa fa-wheelchair font-weight-bold"></i>
          </th>
          <th className="text-center">Bases</th>
          <th className="text-center">Inscripción</th>
        </tr>
      </thead>
      <tbody>
        {cargos.map((cargo, idx) => (
          <tr key={idx}>
            <td>{cargo.denominacion}</td>
            <td>{cargo.nivel}</td>
            <td>{cargo.funcionEspecifica ? 'SI' : ''}</td>
            <td>{cargo.capacidadTerciaria ? 'SI' : ''}</td>
            <td>{cargo.reserva ? 'SI' : ''}</td>
            <td className="text-center">
              <Button variant="primary" size="sm" onClick={handleBases}>
                Bases
              </Button>
            </td>
            <td className="text-center">
              <Button variant="primary" size="sm" onClick={() => handlePostular(cargo)}>
                Postularme
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

const Cargos = ({ rol = 'aspirante', ...props }) => {
  return <AspiranteCargos {...props} />;
};
export default Cargos;
